import { World } from "../ui/globe";
import { useHomepageData } from "../../hooks/useHomepageData";
import { STAR } from "../../constants/imageConstants";

function GlobalPresenceSection() {
  const { data, loading, error } = useHomepageData();

  if (loading) {
    return (
      <div className="min-h-[50vh] flex items-center justify-center text-white">
        Loading...
      </div>
    );
  }

  if (error || !data) {
    return (
      <div className="min-h-[50vh] flex items-center justify-center text-red-500">
        Error loading content
      </div>
    );
  }

  const globalData = data.globalPresenceSection;
  const globeConfig = globalData.globeConfig;
  const colors = globalData.arcColors;
  const sampleArcs = globalData.sampleArcs.map((arc) => ({
    ...arc,
    color: colors[Math.floor(Math.random() * (colors.length - 1))],
  }));
  return (
    <section className="w-full relative h-[50vh] sm:h-[90vh] flex flex-col justify-center items-center">
      <h2 className="text-2xl lg:text-[32px] font-medium text-white text-center my-10 tracking-wide">
        {globalData.title}
      </h2>
      <World data={sampleArcs} globeConfig={globeConfig} />
      <div>
        {globalData.countries && (
          <div className=" w-full flex flex-wrap justify-center gap-4 px-4">
            {globalData.countries.map((country, index) => (
              <section key={index} className="flex items-center">
                <img
                  className="size-4 object-cover"
                  src={STAR}
                  alt="Decorative star"
                />
                <span
                  key={index}
                  className="text-white px-4 py-2 text-sm sm:text-lg"
                >
                  {country}
                </span>
              </section>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}

export default GlobalPresenceSection;
